// tslint:disable:max-file-line-count object-literal-sort-keys
import {
  TBuildingType,
  TPropertyType,
} from './commercial';

export type IJsonQueryType = 'flatrent'
  | 'flatsale'
  | 'newobjectsale'
  | 'commercialrent'
  | 'commercialsale'
  | 'suburbanrent'
  | 'suburbansale';

export interface IJsonQueryTerm<T> {
  type: 'term';
  value: T;
}

export interface IJsonQueryTerms<T> {
  type: 'terms';
  value: T[];
}

export interface IJsonQueryRangeValue {
  gte?: number;
  lte?: number;
}

export interface IJsonQueryRange {
  type: 'range';
  value: IJsonQueryRangeValue;
}

export interface IJsonQueryGeo {
  type: 'geo';
  value: IGeoValue[];
}

export type IGeoValue =
  IJsonQueryLocation
  | IJsonQueryHighway
  | IJsonQueryDistrict
  | IJsonQueryStreet
  | IJsonQueryHouse
  | IJsonQueryUnderground
  | IJsonQueryRailway
  | IJsonQueryDeveloper
  | IJsonQueryNewbuilding
  | IJsonQueryPolygon
  | IJsonQueryCircle;

export interface IJsonQueryLocation {
  type: 'location';
  id: number;
}

export interface IJsonQueryNewbuilding {
  type: 'newobject';
  id: number;
}

export interface IJsonQueryStreet {
  type: 'street';
  id: number;
}

export interface IJsonQueryHouse {
  type: 'house';
  id: number;
}

export interface IJsonQueryUnderground {
  type: 'underground';
  id: number;
}

export interface IJsonQueryRailway {
  type: 'railway';
  id: number;
}

export interface IJsonQueryDistrict {
  type: 'district';
  id: number;
}

export interface IJsonQueryHighway {
  type: 'highway';
  id: number;
}

export interface IJsonQueryDeveloper {
  type: 'builder';
  id: number;
}

export type TCoordinate = [string, string];

export interface IJsonQueryPolygon {
  type: 'polygon';
  name: string;
  coordinates: TCoordinate[];
}

export interface IJsonQueryCircle {
  type: 'distance';
  name: string;
  radius: number;
  center: TCoordinate;
}

export type TRentTime = '0' | '1' | '!1' | '2' | '*';
export const RentTime = {
  FromYear: '0' as '0',
  Daily: '1' as '1',
  FewMonths: '2' as '2',
  NotDaily: '!1' as '!1',
  AnyTerm: '*' as '*',
};

export type TBuildingStatus = 1 | 2;
export const BuildingStatus = {
  Old: 1 as 1,
  New: 2 as 2,
};

export type TPublishPeriod = 0 | -2 | 3600 | 86400 | 864000 | 2592000;
export const PublishPeriod = {
  Any: 0 as 0,
  Today: -2 as -2,
  Hour: 3600 as 3600,
  Day: 86400 as 86400,
  TenDays: 864000 as 864000,
  Month: 2592000 as 2592000,
};

export type THouseMaterial = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
export const HouseMaterial = {
  Brick: 1 as 1,
  Monolith: 2 as 2,
  Panel: 3 as 3,
  Block: 4 as 4,
  Wood: 5 as 5,
  Stalin: 6 as 6,
  Shield: 7 as 7,
  BrickMonolith: 8 as 8,
};

export type TRepair = 1 | 2 | 3 | 4;
export const Repair = {
  Without: 1 as 1,
  Cosmetic: 2 as 2,
  Euro: 3 as 3,
  Design: 4 as 4,
};

export type TMaxPrepay = 0 | 1 | 2 | 3;
export const MaxPrepay = {
  Any: 0 as 0,
  Month: 1 as 1,
  TwoMonths: 2 as 2,
  ThreeMonths: 3 as 3,
};

export type TRoomType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
export const RoomType = {
  Room: 0 as 0,
  FlatOneRoom: 1 as 1,
  FlatTwoRooms: 2 as 2,
  FlatThreeRooms: 3 as 3,
  FlatFourRooms: 4 as 4,
  FlatFiveRooms: 5 as 5,
  FlatManyRooms: 6 as 6,
  FlatFreeLayout: 7 as 7,
  FlatShared: 8 as 8,
  Studio: 9 as 9,
  Bed: 10 as 10,
};

export type TRoomsTotal = 0 | 2 | 3 | 4 | 5;
export const RoomsTotal = {
  Any: 0 as 0,
  Two: 2 as 2,
  Three: 3 as 3,
  Four: 4 as 4,
  Five: 5 as 5,
};

export type TTenant = 1 | 2 | 3 | 4;
export const Tenant = {
  Any: 1 as 1,
  Family: 2 as 2,
  Woman: 3 as 3,
  Man: 4 as 4,
};

export type TBedroomsCount = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
export const BedroomsCount = {
  Any: 0 as 0,
  One: 1 as 1,
  Two: 2 as 2,
  Three: 3 as 3,
  Four: 4 as 4,
  Five: 5 as 5,
  Six: 6 as 6,
  Seven: 7 as 7,
};

export type TParkingType = 1 | 2 | 3 | 4;
export const ParkingType = {
  Rooftop: 1 as 1,
  Underground: 2 as 2,
  Ground: 3 as 3,
  Multilevel: 4 as 4,
};

export type THeatingType = 1 | 2 | 3 | 4 | 5;
export const HeatingType = {
  None: 1 as 1,
  Gas: 2 as 2,
  Coal: 3 as 3,
  Furnace: 4 as 4,
  Fireplace: 5 as 5,
};

export type TLandStatusType = 1 | 2 | 3 | 4 | 5 | 6;
export const LandStatusType = {
  Gardening: 1 as 1,
  IndividualHousingConstruction: 2 as 2,
  IndustrialLand: 3 as 3,
  Farm: 4 as 4,
  CountryhouseNonCommercialPartnership: 5 as 5,
  InvestmentProject: 6 as 6,
};

export type TWCType = 0 | 1 | 2;
export const WCType = {
  Any: 0 as 0,
  United: 1 as 1,
  Separated: 2 as 2,
};

export type TSuburbanWCType = 0 | 1 | 2;
export const SuburbanWCType = {
  Any: 0 as 0,
  Inside: 1 as 1,
  Outside: 2 as 2,
};

export type TWCCount = 0 | 1 | 2 | 3 | 4;
export const WCCount = {
  Any: 0 as 0,
  One: 1 as 1,
  Two: 2 as 2,
  Three: 3 as 3,
  Four: 4 as 4,
};

export type TWindowsType = -1 | 0 | 1;
export const WindowsType = {
  Any: -1 as -1,
  Courtyard: 0 as 0,
  Street: 1 as 1,
};

export type TMetroTravelType = '-2' | '-1' | '0' | '1' | '2';
export const MetroTravelType = {
  Any: '0' as '0',
  AgentFoot: '1' as '1',
  AgentTransport: '-1' as '-1',
  MapFoot: '2' as '2',
  MapTransport: '-2' as '-2',
};

export type TLayoutType = 0 | 1 | 2;
export const LayoutType = {
  Any: 0 as 0,
  IsolatedRooms: 1 as 1,
  UnitedRooms: 2 as 2,
};

export type TGarageType = 0 | 1 | 2 | 3;
export const GarageType = {
  Any: 0 as 0,
  CarPlace: 1 as 1,
  Garage: 2 as 2,
  Box: 3 as 3,
};

export type TGarageKind = 1 | 2 | 3 | 4;
export const GarageKind = {
  Builtin: 1 as 1,
  Capital: 2 as 2,
  Shell: 3 as 3,
  Selfbuilt: 4 as 4,
};

export type TGarageMaterial = 1 | 2;
export const GarageMaterial = {
  Metal: 1 as 1,
  Brick: 2 as 2,
};

export type TGarageStatus = 1 | 2 | 3;
export const GarageStatus = {
  Cooperative: 1 as 1,
  Ownership: 2 as 2,
  Agreement: 3 as 3,
};

export type TPriceType = 1 | 2;
export const PriceType = {
  SM: 1 as 1,
  Total: 2 as 2,
};

export type TSaleType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
export const SaleType = {
  Any: 0 as 0,
  Free: 1 as 1,
  Alternative: 2 as 2,
  F3: 3 as 3,
  Reassignment: 4 as 4,
  GSKContract: 5 as 5,
  PreliminaryContract: 6 as 6,
  InvestmentContract: 7 as 7,
};

export type TElevators = 0 | 1 | 2 | 3 | 4;
export const Elevators = {
  Any: 0 as 0,
  One: 1 as 1,
  Two: 2 as 2,
  Three: 3 as 3,
  Four: 4 as 4,
};

export type TCurrencyType = 1 | 2 | 3;
export const CurrencyType = {
  Dollar: 1 as 1,
  Rouble: 2 as 2,
  Euro: 3 as 3,
};

export type TObjectType = 1 | 2 | 3 | 4;
export const ObjectType = {
  House: 1 as 1,
  Housepart: 2 as 2,
  Land: 3 as 3,
  Townhouse: 4 as 4,
};

export type TOfficeType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 9 | 10 | 11 | 12;
export const OfficeType = {
  Office: 1 as 1,
  TradeArea: 2 as 2,
  Warehouse: 3 as 3,
  PublicCatering: 4 as 4,
  FreeAppointmentObject: 5 as 5,
  Garage: 6 as 6,
  Manufacture: 7 as 7,
  AutoService: 9 as 9,
  Business: 10 as 10,
  Building: 11 as 11,
  DomesticServices: 12 as 12,
};

export type TCategoryType = 'commercialLandRent' | 'commercialLandSale';
export const CategoryType = {
  CommercialLandRent: 'commercialLandRent' as 'commercialLandRent',
  CommercialLandSale: 'commercialLandSale' as 'commercialLandSale',
};

export type TBuildingClassType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
export const BuildingClassType = {
  A: 1 as 1,
  APlus: 2 as 2,
  B: 3 as 3,
  BPlus: 4 as 4,
  C: 5 as 5,
  CPlus: 6 as 6,
  D: 7 as 7,
  BMinus: 8 as 8,
};

export type TBuildingElevatorType = 1 | 2 | 3;
export const BuildingElevatorType = {
  Service: 1 as 1,
  Telpher: 2 as 2,
  Passenger: 3 as 3,
};

export type TBuildingCraneType = 1 | 2 | 3 | 4;
export const BuildingCraneType = {
  Overhead: 1 as 1,
  Beam: 2 as 2,
  Railway: 3 as 3,
  Goat: 4 as 4,
};

export type TBuildingGatesType = 1 | 2 | 3;
export const BuildingGatesType = {
  Ramp: 1 as 1,
  Dock: 2 as 2,
  Ground: 3 as 3,
};

export type TBuildingHeatingType = 1 | 2 | 3;
export const BuildingHeatingType = {
  Without: 1 as 1,
  Central: 2 as 2,
  Autonomous: 3 as 3,
};

export type TPlacementType = 1 | 2;
export const PlacementType = {
  ShoppingMall: 1 as 1,
  StreetRetail: 2 as 2,
};

export type TEntranceType = 1 | 2 | 3 | 4;
export const EntranceType = {
  SeparateCourtyard: 1 as 1,
  SeparateStreet: 2 as 2,
  CommonCourtyard: 3 as 3,
  CommonStreet: 4 as 4,
};

export type TConditionType = 1 | 2 | 3 | 4 | 5 | 6;
export const ConditionType = {
  OfficeDecoration: 1 as 1,
  FullDecorationNeeded: 2 as 2,
  MajorRepairNeeded: 3 as 3,
  CosmeticRepairNeeded: 4 as 4,
  RegularRepair: 5 as 5,
  DesignerRepair: 6 as 6,
};

export type THouseLineType = 1 | 2;
export const HouseLineType = {
  First: 1 as 1,
  Second: 2 as 2,
};

export type TEstateType = 1 | 2;
export const EstateType = {
  Owned: 1 as 1,
  Rent: 2 as 2,
};

export type TContractType = 1 | 2 | 3 | 4;
export const ContractType = {
  DirectRent: 1 as 1,
  SubRent: 2 as 2,
  PermTransfer: 3 as 3,
  ObjSale: 4 as 4,
};

export type TSortQuality = 0 | 1 | undefined;

export type TSortValue = 'default'
  | 'price_object_order'
  | 'price_square_order'
  | 'area_order'
  | 'site_order'
  | 'walking_time'
  | 'mcad'
  | 'street_name'
  | 'id_user'
;

export const EOfferCategory = {
  AutoService: 'autoService',
  Bedroom: 'bedroom',
  Building: 'building',
  CommercialLand: 'commercialLand',
  DomesticServices: 'domesticServices',
  Flat: 'flat',
  FlatNew: 'flatNew',
  FlatOld: 'flatOld',
  FreeAppointmentOffice: 'freeAppointmentOffice',
  Garage: 'garage',
  House: 'house',
  Housepart: 'housepart',
  Manufacture: 'manufacture',
  Office: 'office',
  Part: 'part',
  PublicCatering: 'publicCatering',
  ReadyMadeBusiness: 'readyMadeBusiness',
  Room: 'room',
  Storehouse: 'storehouse',
  Townhouse: 'townhouse',
  Tradearea: 'tradearea',
};

export type TFacility =
  'has_furniture' |
  'has_fridge' |
  'has_washer' |
  'has_kitchen_furniture' |
  'internet' |
  'tv' |
  'conditioner' |
  'dish_washer' |
  'phone' |
  'bath' |
  'shower' |
  'kids' |
  'pets' |
  'bathhouse' |
  'garage' |
  'pool' |
  'security'
;
export const Facility: {
  [index: string]: TFacility;
} = {
  Bath: 'bath' as 'bath',
  Conditioner: 'conditioner' as 'conditioner',
  Dishwasher: 'dish_washer' as 'dish_washer',
  Fridge: 'has_fridge' as 'has_fridge',
  Garage: 'garage' as 'garage',
  Internet: 'internet' as 'internet',
  KidsAllowed: 'kids' as 'kids',
  KitchenFurniture: 'has_kitchen_furniture' as 'has_kitchen_furniture',
  PetsAllowed: 'pets' as 'pets',
  Phone: 'phone' as 'phone',
  Pool: 'pool' as 'pool',
  Sauna: 'bathhouse' as 'bathhouse',
  Security: 'security' as 'security',
  Shower: 'shower' as 'shower',
  TV: 'tv' as 'tv',
  Washer: 'has_washer' as 'has_washer',
};

export type TSuburbanUtility =
  'gas' |
  'electricity' |
  'has_drainage' |
  'has_water'
;
export const SuburbanUtility: {
  [index: string]: TSuburbanUtility,
} = {
  Gas: 'gas' as 'gas',
  Electricity: 'electricity' as 'electricity',
  Drainage: 'has_drainage' as 'has_drainage',
  Water: 'has_water' as 'has_water',
};

export interface IJsonQueryTermsParams {
  bs_center?: IJsonQueryTerms<number>;
  building_class_type?: IJsonQueryTerms<TBuildingClassType>;
  building_class_type__warehouse?: IJsonQueryTerms<TBuildingClassType>;
  building_cranage_types_type?: IJsonQueryTerms<TBuildingCraneType>;
  building_gates_type?: IJsonQueryTerms<TBuildingGatesType>;
  building_heating_type?: IJsonQueryTerms<TBuildingHeatingType>;
  building_house_line_type?: IJsonQueryTerms<THouseLineType>;
  building_house_line_type__shopping_area?: IJsonQueryTerms<THouseLineType>;
  building_lift_types_type?: IJsonQueryTerms<TBuildingElevatorType>;
  building_type2?: IJsonQueryTerms<TBuildingType>;
  building_type__building?: IJsonQueryTerms<TBuildingType>;
  category?: IJsonQueryTerms<TCategoryType>;
  composition?: IJsonQueryTerms<TTenant>;
  condition_type?: IJsonQueryTerms<TConditionType>;
  condition_type__free_appointment_object?: IJsonQueryTerms<TConditionType>;
  condition_type__industry?: IJsonQueryTerms<TConditionType>;
  contract?: IJsonQueryTerms<TContractType>;
  description_exclude?: IJsonQueryTerms<string>;
  description_include?: IJsonQueryTerms<string>;
  estate_type?: IJsonQueryTerms<TEstateType>;
  garage_garage_type?: IJsonQueryTerms<TGarageKind>;
  garage_material?: IJsonQueryTerms<TGarageMaterial>;
  garage_status?: IJsonQueryTerms<TGarageStatus>;
  garage_type?: IJsonQueryTerms<TGarageType>;
  heating_source_type?: IJsonQueryTerms<THeatingType>;
  house_material?: IJsonQueryTerms<THouseMaterial>;
  input_type?: IJsonQueryTerms<TEntranceType>;
  kp_id?: IJsonQueryTerms<number>;
  land_status?: IJsonQueryTerms<TLandStatusType>;
  object_type?: IJsonQueryTerms<TObjectType>;
  office_type?: IJsonQueryTerms<TOfficeType>;
  parking_type?: IJsonQueryTerms<TParkingType>;
  placement_type?: IJsonQueryTerms<TPlacementType>;
  property_type?: IJsonQueryTerms<TPropertyType>;
  region?: IJsonQueryTerms<number>;
  repair?: IJsonQueryTerms<TRepair>;
  room?: IJsonQueryTerms<TRoomType>;
  rooms_count?: IJsonQueryTerms<TRoomsTotal>;
  sost_type?: IJsonQueryTerms<TSaleType>;
  status?: IJsonQueryTerms<number>;
  specialty_types?: IJsonQueryTerms<number>;
  year?: IJsonQueryTerms<number>;
}

export interface IJsonQueryBooleanParams {
  enter?: IJsonQueryTerm<boolean>;
  demolished_in_moscow_programm?: IJsonQueryTerm<boolean>;
  has_video?: IJsonQueryTerm<boolean>;
}

export interface IJsonQueryInfrastructureParams {
  has_light?: IJsonQueryTerm<boolean>;
  has_electricity?: IJsonQueryTerm<boolean>;
  has_heating?: IJsonQueryTerm<boolean>;
  has_water?: IJsonQueryTerm<boolean>;
  has_extinguishing_system?: IJsonQueryTerm<boolean>;
  infrastructure_has_slot_machines?: IJsonQueryTerm<boolean>;
  infrastructure_has_notary_office?: IJsonQueryTerm<boolean>;
  infrastructure_has_hotel?: IJsonQueryTerm<boolean>;
  infrastructure_has_office_space?: IJsonQueryTerm<boolean>;
  infrastructure_has_atm?: IJsonQueryTerm<boolean>;
  infrastructure_has_aquapark?: IJsonQueryTerm<boolean>;
  infrastructure_has_cafe?: IJsonQueryTerm<boolean>;
  infrastructure_has_clothes_studio?: IJsonQueryTerm<boolean>;
  infrastructure_has_basement?: IJsonQueryTerm<boolean>;
  infrastructure_has_tire?: IJsonQueryTerm<boolean>;
  infrastructure_has_fitness_centre?: IJsonQueryTerm<boolean>;
  infrastructure_has_shopping_area?: IJsonQueryTerm<boolean>;
  infrastructure_has_pool?: IJsonQueryTerm<boolean>;
  infrastructure_has_cinema?: IJsonQueryTerm<boolean>;
  infrastructure_has_car_wash?: IJsonQueryTerm<boolean>;
  infrastructure_has_food_court?: IJsonQueryTerm<boolean>;
  infrastructure_has_medical_center?: IJsonQueryTerm<boolean>;
  infrastructure_has_restaurant?: IJsonQueryTerm<boolean>;
  infrastructure_has_video_surveillance?: IJsonQueryTerm<boolean>;
  infrastructure_has_minimarket?: IJsonQueryTerm<boolean>;
  infrastructure_has_beauty_shop?: IJsonQueryTerm<boolean>;
  infrastructure_has_warehouse?: IJsonQueryTerm<boolean>;
  infrastructure_has_bowling?: IJsonQueryTerm<boolean>;
  infrastructure_has_baby_sitting?: IJsonQueryTerm<boolean>;
  infrastructure_has_canteen?: IJsonQueryTerm<boolean>;
  infrastructure_has_pharmacy?: IJsonQueryTerm<boolean>;
  infrastructure_has_supermarket?: IJsonQueryTerm<boolean>;
  infrastructure_has_buffet?: IJsonQueryTerm<boolean>;
  infrastructure_has_conference_room?: IJsonQueryTerm<boolean>;
  infrastructure_has_inspection_pit?: IJsonQueryTerm<boolean>;
  infrastructure_has_park?: IJsonQueryTerm<boolean>;
  infrastructure_has_rink?: IJsonQueryTerm<boolean>;
  infrastructure_has_hour_security?: IJsonQueryTerm<boolean>;
  infrastructure_has_game_room?: IJsonQueryTerm<boolean>;
  infrastructure_has_exhibition_and_warehouse_complex?: IJsonQueryTerm<boolean>;
  infrastructure_has_bank_department?: IJsonQueryTerm<boolean>;
  infrastructure_has_automatic_gates?: IJsonQueryTerm<boolean>;
  infrastructure_has_central_reception?: IJsonQueryTerm<boolean>;
  infrastructure_has_entry_by_pass?: IJsonQueryTerm<boolean>;
  infrastructure_has_car_service?: IJsonQueryTerm<boolean>;
  infrastructure_has_studio?: IJsonQueryTerm<boolean>;
}

export interface IJsonQuery extends IJsonQueryTermsParams, IJsonQueryBooleanParams {
  _type: IJsonQueryType;
  engine_version: IJsonQueryTerm<number>;

  apartment?: IJsonQueryTerm<boolean>;
  balconies?: IJsonQueryRange;
  bath?: IJsonQueryTerm<boolean>;
  bathhouse?: IJsonQueryTerm<boolean>;
  bedroom_total?: IJsonQueryRange;
  bs_center_id?: IJsonQueryTerm<number>;
  build_quarter?: IJsonQueryTerm<number>;
  build_year?: IJsonQueryTerm<number>;
  building_status?: IJsonQueryTerm<TBuildingStatus>;
  ceiling_height?: IJsonQueryRange;
  cl?: IJsonQueryTerm<boolean>;
  commission_type?: IJsonQueryTerm<number>;
  conditioner?: IJsonQueryTerm<boolean>;
  contact?: IJsonQueryTerm<string>;
  currency?: IJsonQueryTerm<TCurrencyType>;
  developer_sort_type?: IJsonQueryTerm<string>;
  dish_washer?: IJsonQueryTerm<boolean>;
  electricity?: IJsonQueryTerm<boolean>;
  floor?: IJsonQueryRange;
  floorn?: IJsonQueryRange;
  foot_min?: IJsonQueryRange;
  for_day?: IJsonQueryTerm<TRentTime>;
  from_developer?: IJsonQueryTerm<boolean>;
  from_jk?: IJsonQueryTerm<boolean>;
  from_mcad_km?: IJsonQueryRange;
  from_offrep?: IJsonQueryTerm<boolean>;
  garage?: IJsonQueryTerm<boolean>;
  gas?: IJsonQueryTerm<boolean>;
  geo?: IJsonQueryGeo;
  hand_over?: IJsonQueryTerm<boolean>;
  has_decoration?: IJsonQueryTerm<boolean>;
  has_drainage?: IJsonQueryTerm<boolean>;
  has_electricity?: IJsonQueryTerm<boolean>;
  has_equipment?: IJsonQueryTerm<boolean>;
  has_extinguishing_system?: IJsonQueryTerm<boolean>;
  has_fridge?: IJsonQueryTerm<boolean>;
  has_furniture?: IJsonQueryTerm<boolean>;
  has_heating?: IJsonQueryTerm<boolean>;
  has_kitchen_furniture?: IJsonQueryTerm<boolean>;
  has_light?: IJsonQueryTerm<boolean>;
  has_washer?: IJsonQueryTerm<boolean>;
  has_water?: IJsonQueryTerm<boolean>;
  house_year?: IJsonQueryRange;
  id?: IJsonQueryTerm<number>;
  id_user?: IJsonQueryTerm<number>;
  include_new_moscow?: IJsonQueryTerm<boolean>;
  internet?: IJsonQueryTerm<boolean>;
  ipoteka?: IJsonQueryTerm<boolean>;
  isWCfixed?: boolean;
  is_basement?: IJsonQueryTerm<boolean>;
  is_by_homeowner?: IJsonQueryTerm<boolean>;
  is_by_commercial_owner?: IJsonQueryTerm<boolean>;
  is_first_floor?: IJsonQueryTerm<boolean>;
  is_in_hidden_base?: IJsonQueryTerm<boolean>;
  is_semibasement?: IJsonQueryTerm<boolean>;
  jk_flat_type_id?: IJsonQueryTerm<string>;
  kids?: IJsonQueryTerm<boolean>;
  kitchen?: IJsonQueryRange;
  lift_service?: IJsonQueryRange;
  lifts?: IJsonQueryTerm<TElevators>;
  living_area?: IJsonQueryRange;
  loggia?: IJsonQueryTerm<boolean>;
  maxprepay?: IJsonQueryTerm<TMaxPrepay>;
  multi_id?: IJsonQueryTerm<number>;
  not_last_floor?: IJsonQueryTerm<boolean>;
  only_flat?: IJsonQueryTerm<boolean>;
  only_foot?: IJsonQueryTerm<TMetroTravelType>;
  page?: IJsonQueryTerm<number>;
  penthouse?: IJsonQueryTerm<boolean>;
  pets?: IJsonQueryTerm<boolean>;
  phone?: IJsonQueryTerm<boolean>;
  pool?: IJsonQueryTerm<boolean>;
  price?: IJsonQueryRange;
  price_sm?: IJsonQueryTerm<boolean>;
  promo?: IJsonQueryTerm<boolean>;
  publish_period?: IJsonQueryTerm<TPublishPeriod>;
  quality?: IJsonQueryTerm<boolean>;
  room_area?: IJsonQueryRange;
  room_type?: IJsonQueryTerm<TLayoutType>;
  rooms_for_sale?: IJsonQueryRange;
  security?: IJsonQueryTerm<boolean>;
  shower?: IJsonQueryTerm<boolean>;
  site?: IJsonQueryRange;
  sort?: IJsonQueryTerm<string>;
  total_area?: IJsonQueryRange;
  tv?: IJsonQueryTerm<boolean>;
  wc?: IJsonQueryRange;
  wc_site?: IJsonQueryTerm<TSuburbanWCType>;
  wc_type?: IJsonQueryTerm<TWCType>;
  windows_type?: IJsonQueryTerm<TWindowsType>;
  with_newobject?: IJsonQueryTerm<boolean>;
  wp?: IJsonQueryTerm<boolean>;
  yeargte?: IJsonQueryTerm<number>;
  zalog?: IJsonQueryTerm<boolean>;
}
